import { makeStyles } from '@mui/styles';
const useStyles = makeStyles(() => ({
  rentDetailsForm: {
    marginTop: '17px',
  },
}));

export default useStyles;
